import React from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';




const styles = theme => ({
  root:{
    display: "flex",
    flexDirection:"row",
    justifyContent:"center",
    zIndex: 100000,

    position:"fixed",
    top: 0,
    left: 0,
    width: "100%",
    background: theme.palette.background.dark
  },
  progress: {
    margin: "auto",
  },
  wrapper:{
    display: "flex",
    flexDirection:"column",
    justifyContent:"center",
    alignContent:"center",
  },
  logo:{
    display:"block",
    position:"relative",

    animationName: "spin",
    animationDuration: "5000ms",
    animationIterationCount: "infinite",
    animationTimingFunction: "linear",
  },

  '@keyframes spin': {
    from: {transform:"rotate(0deg)"},
    to: {transform:"rotate(360deg)"}
  }
});

const Preloader = (props) => {
  const { classes, height, iconSize } = props
  return (
    <div className={classes.root} style={{minHeight: height ? height: "100vh"}}>
      <div className={classes.wrapper}>
        <img  className={classes.logo} width={iconSize ? iconSize*100+"%" : "100%"} height="auto" src="https://i.imgur.com/kAfVurb.png" />
      </div>
    </div>
  );
};

Preloader.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Preloader);



// WEBPACK FOOTER //
// ./src/components/reusableComponents/Preloader.js